export const REPORT_LOGO_PATH = window.__GENERATED_CONSTANTS__.REPORT_LOGO_PATH

export const PaperSize = {
    LETTER: window.__GENERATED_CONSTANTS__.PaperSize.LETTER,
    A4: window.__GENERATED_CONSTANTS__.PaperSize.A4
}

export const PaperOrientation = {
    PORTRAIT: window.__GENERATED_CONSTANTS__.PaperOrientation.PORTRAIT,
    LANDSCAPE: window.__GENERATED_CONSTANTS__.PaperOrientation.LANDSCAPE
}


// WEBPACK FOOTER //
// ./web/js/pdf/constants.js